import { UserCommitmentRankingEntry } from 'models/ranking/commitmentRanking/entry/UserCommitmentRankingEntry';

export class UserCommitmentRankingEntryService {
	toModel(ranking) {
		return new UserCommitmentRankingEntry(ranking);
	}
}
